const UPDATE_CLASS_AND_VOTE_LOADER = 'UPDATE_CLASS_AND_VOTE_LOADER';

export default {
    UPDATE_CLASS_AND_VOTE_LOADER
}